import { Box, Button, Stack, Typography, useTheme } from '@mui/material';

export interface PageTabMenuProps {
  options: {
    title: string,
    value: number,
  }[],
  onChangeTab: (tab: number) => void,
  tabValue: number,
}

export default function PageTabMenu({ options, onChangeTab, tabValue }: PageTabMenuProps) {
  const theme = useTheme()
  return (
    <div data-testid='pageTabMenu-render-test'>
      <Stack justifySelf='left' direction='row' justifyContent='space-evenly' spacing={2}>
        {options.map((option, index) => (
          <>
            <Button
              sx={{
                transition: '0.5s',
                ':hover': {
                  bgcolor: 'transparent',
                  boxShadow: tabValue !== option.value ? `0px 2px ${theme.palette.grey[300]}bb` : `0px 2px ${theme.palette.primary.lighter}`,
                  transition: '0.5s'
                },
                borderRadius: 0,
                paddingX: 2,
                boxShadow: tabValue === option.value ? `0px 2px ${theme.palette.primary.main}` : 0,
                textTransform: 'none'
              }}
              onClick={() => onChangeTab(option.value)}
              disableRipple
            >
              <Typography typography='body-md'>
                {option.title}
              </Typography>
            </Button>
            {
              index < options.length - 1 &&
              <Box width='1px' bgcolor='black' />
            }
          </>
        ))}
      </Stack>
    </div>
  )
}
